import { render, staticRenderFns } from "./TransactionX.vue?vue&type=template&id=9e4b63f2&"
import script from "./TransactionX.vue?vue&type=script&lang=js&"
export * from "./TransactionX.vue?vue&type=script&lang=js&"
import style0 from "./TransactionX.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports